<template>
  <div>
    <div v-if="!isNewLandingpage" :class="['btn-wrapper']">
      <img-v3 :src="formItem.icon_url" alt="" v-if="formItem.icon_url" />
      <input
        type="button"
        :value="formItem.title"
        :style="isCanSubmit && submitStyle"
        :class="{ 'register-btn': 1, active: isCanSubmit }"
        @click="login"
      />
    </div>
    <div v-else class="page-foot-btn">
      <div v-for="(privacy, i) in privacyOptions" :key="i" class="foot-text">
        <div class="circle" v-if="(!privacy.value && !isAgreePrivacy && _area.value && phoneNumber.length >= 11) || (!privacy.value && !isAgreePrivacy && policyClassCircle)"></div>
        <img-v3
          @click="handleClick('agree', privacy, i)"
          :class="['foot-check']"
          :src="privacy[`icon_${privacy.value ? 'is' : 'un'}_check_url`]"
          alt="icon_un_check_url"
        />
        <div
          v-if="!privacy.value && !isAgreePrivacy && policyClassError && phoneNumber.length >= 11 && _area.value"
          class="foot-check-cursor"
        />
        <span @click="handleClick('agree', privacy, i)">{{privacy.desc}}</span>
        <span
          @click="handleClick('rule', privacy, i)"
          :style="{
            color: privacy.font_color,
          }"
        >
          {{ privacy.title }}
        </span>
      </div>

      <div
        @click="login"
        :style="{
          'background-color': formItem.background_color,
          color: formItem.font_color,
        }"
        class="foot-btn font-36"
      >
        {{ formItem.title }}
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import { post } from "../../tools/request";
import { showDialog, showAlertDialog, showLoadingToast } from "../../tools/Tip";
import { emitFormUpdate ,openWebview} from "../../tools/utils";
import { ends } from "../../tools/constant";
export default {
  props: [
    "formItem",
    "isCanSubmit",
    "phoneNumber",
    "product",
    "identity",
    "areaId",
    "idx",
    "omegaItem",
    "policyClassError",
    "policyClassCircle",
  ],
  data() {
    return {
      isAgreePrivacy: false,
    };
  },
  mounted() {},
  computed: {
    ...mapState([
      "_area",
    ]),
    params() {
      return new URLSearchParams(location.search);
    },
    location_country() {
      return this.params.get("location_country");
    },
    isWhatsApp() {
      return this.params.get("from_end") === "WhatsappConf";
    },
    submitStyle() {
      return {
        background: this.formItem.background_color,
        color: this.formItem.font_color,
      };
    },
    privacyOptions() {
      return this.formItem.privacy_options || [];
    },
    isNewLandingpage() {
      return this.formItem.style === "h5_br" || this.formItem.style === "whatsapp_br";
    },
  },
  watch: {
    isCanSubmit(v) {
      console.log(v, "---");
    },
    isAgreePrivacy(newV, oldV) {
      this.privacyOptions.forEach((item) => {
        if((!item.value && !this.isAgreePrivacy && this._area.value && this.phoneNumber.length >= 11) || (!item.value && !newV && this.policyClassCircle)) {
          this.reportPoints()
        }
      })
    },
    privacyOptions: {
      handler(newV, oldV) {
        this.privacyOptions.forEach((item) => {
          if((!item.value && !this.isAgreePrivacy && this._area.value && this.phoneNumber.length >= 11) || (!item.value && !this.isAgreePrivacy && this.policyClassCircle)) {
          this.reportPoints()

          }
        })
      },
      deep: true,
      // immediate: true, //页面初始化时立即调用
    },
    phoneNumber(newV, oldV) {
      this.privacyOptions.forEach((item) => {
        if(!item.value && !this.isAgreePrivacy && this._area.value && this.phoneNumber.length >= 11) {
          this.reportPoints()
        }
      })
    },
    policyClassCircle(newV, oldV) {
      this.privacyOptions.forEach((item) => {
        if (!item.value && !this.isAgreePrivacy && this.policyClassCircle) {
          this.reportPoints()

        }
      })
    },
    _area: {
      handler(newV, oldV) {
        this.privacyOptions.forEach((item) => {
          if(!item.value && !this.isAgreePrivacy && this._area.value && this.phoneNumber.length >= 11) {
          this.reportPoints()

          }
        })
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations(["setState"]),
    // 上报埋点
    reportPoints() {
      try{
        Omega.trackEvent("ibt_landingpage_privacy_circle_sw", "", {
        oid: this.omegaItem.oid,
        location_country_code: this.omegaItem.country,
        channel: this.omegaItem.channel,
        end: this.omegaItem.end,
      });
      } catch(e) {

      }
      
    },
    login() {
      if (this.isNewLandingpage) {
        // new landingpage提交手机号埋点
        Omega.trackEvent("ibt_onboarding_landingpageclicknext_ck", "", {
          ...this.omegaItem,
          fbp: this.$cookies.get('_fbp'), // 可选，可能有多个，需要和domain匹配
          fbc: this.$cookies.get('_fbc'), // 可选，可能有多个或没有，需要和domain匹配
        });
      } else {
        if (!this.isCanSubmit) {
          gtm({
            event: "s1PassportRegister",
            PhoneNumber: "blank",
            Country: this.location_country,
            error: "true",
          });
          return;
        } else {
          gtm({
            event: "s1PassportRegister",
            PhoneNumber: "valid",
            Country: this.location_country,
            error: "false",
          });
        }
      }

      showLoadingToast(this, this.$t("加载中"), 500);

      if (this.isWhatsApp) {
        if (!this.isNewLandingpage) {
          // 老版本landingpage wa注册埋点
          Omega.trackEvent("ibt_gd_whatsapp_register_ck");
        }
        // let up = new URLSearchParams(location.search);
        // up.set("countryCode", this.location_country);
        // up.set("phone", this.phoneNumber);
        // up.set("product", this.product);
        // up.set("identity", this.identity);
        // up.set("city", this.areaId);
        // post(this.formItem.link, up)
        //   .then((data) => {
        //     if (data) {
        //       window.location.href = data;
        //     }
        //   })
        //   .catch((err) => {
        //     Omega.trackError(
        //       "tech_ibt_onboarding_landingpagegetwhatsapp_bt",
        //       err.errno,
        //       err.errmsg,
        //       {
        //         url: this.formItem.link,
        //         resp: err,
        //         desc: "WhatsApp landingpage获取whatsapp接口",
        //       }
        //     );
        //     console.log(err);
        //     const { errno, errmsg } = err;
        //     if (+errno === 400001) {
        //       showAlertDialog(
        //         this,
        //         this.$t("GDriver_optimize_Phone_No_boYK").replace(
        //           /{{phone_number}}/,
        //           this.phoneNumber
        //         )
        //       );
        //     } else {
        //       showAlertDialog(this, errmsg);
        //     }
        //   })
        //   .finally(() => {
        //     this.toast.hide();
        //   });
        this.$emit('doLoginBr', 'WALogin', this.formItem.link)
      } else {
        // this.checkPhone();
        if (!this.isNewLandingpage) {
          // 老版本landingpage H5注册埋点
          Omega.trackEvent("tone_p_x_login_confm_newuser_ck");
        }

        this.$emit('doLoginBr', 'H5Login')
      }
    },
    // checkPhone() {
    //   const loginAction = (callback, fallback) => {
    //     return login.checkPhone(this.phoneNumber, callback, fallback);
    //   };

    //   loginAction(
    //     (response) => {
    //       const { ticket, cell, uid } = response;
    //       this.setState({ _ticket: ticket, _cell: cell, _uuid: uid });

    //       this.$router.replace({ name: "home" });
    //       fireBase("tone_p_x_login_success_sw");
    //     },
    //     (error) => {
    //       console.log(error);
    //     }
    //   );
    // },
    handleClick(type, config, index) {
      switch (type) {
        case "agree":
          this.formItem.privacy_options[index].value = !config.value;
          this.isAgreePrivacy = config.value;
          try{
            Omega.trackEvent("ibt_landingpage_privacy_num_ck", "", {
              oid: this.omegaItem.oid,
              location_country_code: this.omegaItem.country,
              channel: this.omegaItem.channel,
              end: this.omegaItem.end,
              checked_status: this.isAgreePrivacy
            });
          } catch(e) {}
          
          emitFormUpdate(this, this.idx);
          break;
        case "rule":
          let lang = this.params.get("lang");
          let url =
            config.link ||
            `https://common.didiglobal.com/common/v6/driver/law?location_country=${this.location_country}&lang=${lang}`;

          if (ends.inApp) {
            openWebview(url)
          } else {
            window.location.href = url;
          }
          break;
        default:
          break;
      }
    },
  },
  components: {},
};
</script>
<style lang="scss" scoped>
@import "../../css/var.scss";
.btn-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 0.4rem;
  margin-top: 0.24rem;
  > img {
    position: absolute;
    left: 0.76rem;
    width: 0.4rem;
    height: 0.4rem;
  }
  > input {
    display: block;
    width: 100%;
    height: 1.06rem;
    padding: 0.33rem 0;
    border-radius: 0.12rem;
    text-align: center;
    color: #999;
    background: $main-bg-color;
    font-weight: 700;
    &.active {
      color: #fff;
      background: $main-orange;
    }
  }
}
.page-foot-btn {
  position: fixed;
  left: 0.24rem;
  bottom: 0;
  width: calc(100% - 0.48rem);
  height: 2.6rem;
  padding: 0.32rem 0.32rem 0;
  box-sizing: border-box;
  color: #91a0b4;
  font-size: 0.28rem;
  background: #ffffff;
  box-shadow: 0 -0.2rem 0.2rem 0 rgba(0, 0, 0, 0.04);
  border-radius: 0.12rem 0.12rem 1px 1px;
  .foot-text {
    display: flex;
    align-items: center;
    span {
      margin-left: 0.07rem;
    }
    .foot-check-cursor {
      position: relative;
      width: 0.6rem;
      height: 0.6rem;
      top: 0.4rem;
      left: -0.2rem;
      background-image: url(../../images/hand@2x.png);
      background-size: cover;
    }
  }
  .foot-check {
    width: 0.36rem;
    height: 0.36rem;
    margin-right: 0.1rem;
    position: relative;
    z-index: 2;
  }
  .circle {
    width: 0.3rem;
    height: 0.3rem;
    position: absolute;
    z-index: 1;
    left: 0.29rem;
    border: 3px solid rgba(251, 226, 98);
    border-radius: 50%;
    animation: circle 0.8s ease-in-out infinite;
  }
  @keyframes circle {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      transform: scale(2);
      opacity: 0.5;
    }
    100% {
      transform: scale(2.8);
      opacity: 0;
    }
  }
  .foot-btn {
    margin-top: 0.33rem;
    height: 1.08rem;
    line-height: 1.08rem;
    border-radius: 0.12rem;
    text-align: center;
    font-size: 0.36rem;
  }
}
</style>


